package pwgs.ui.scenes.login

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class ALoginControllerFe(props: pwgs.ui.scenes.login.LoginSceneProps, scene: MLoginScene)
 : AController<pwgs.ui.scenes.login.LoginSceneProps, pwgs.ui.scenes.login.LoginSceneModel, LoginSceneState>(props, scene) {

    val backend = LoginControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_login(baseUrl: kotlin.String) {
        launchOnDefaultControllerScope {
            render(backend.login(baseUrl))
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class LoginControllerBeProxy(private val controller: ALoginControllerFe) {

    suspend fun login(baseUrl: kotlin.String): pwgs.ui.scenes.login.LoginSceneModel {
        @Serializable
        class ParamsWrapper(val baseUrl: kotlin.String)
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper(baseUrl))
        val p = RmiParams(
            action = "pwgs.ui.scenes.login.LoginControllerBe.login",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.login.LoginSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.login.LoginSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.login.LoginSceneModel.serializer())
        }
    }

}
